import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/user/line_back_ico_l.png'


const _withScopeId = n => (_pushScopeId("data-v-ae891dc6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "BACK", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "설문조사", -1))
const _hoisted_8 = {
  class: "board_wrap",
  id: "servey_list"
}
const _hoisted_9 = { class: "survey_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "in_back_btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.backMyPage && $setup.backMyPage(...args)))
          }, _hoisted_6),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: "#",
                        onClick: ($event: any) => ($setup.moveDetail(item.idx))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(item.title), 1),
                          _createElementVNode("span", null, "종료일 " + _toDisplayString($setup.dateFormat(item.endDate)), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 256))
              ])
            ]),
            _createVNode(_component_PageBtn, {
              totalLength: $setup.list.length,
              perPage: $setup.list.size,
              "current-page": $setup.list.currentPage,
              onOnPaging: $setup.handlePageChange
            }, null, 8, ["totalLength", "perPage", "current-page", "onOnPaging"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.modal.content,
      no: $setup.modal.cancle,
      yes: $setup.modal.confirm,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "no", "yes", "onClose"])
  ], 64))
}